import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ImpactSideNav extends Vue {
  public showCreateGoal() {
    this.$router.push({
      path: '/impact-dashboard-goal',
      query: { name: 'dashboard' },
    });
  }
  public showPerformance() {
    this.$router.push({
      path: '/impact-performance',
      query: { name: 'performance' },
    });
  }

  public showOverallProgress() {
    this.$router.push({
      path: '/impact-ela-growth',
      query: { name: 'growth' },
    });

  }
  public showNcpatProgress() {
    this.$router.push({
      path: '/impact-growth',
      query: { name: 'parcc' },
    });

  }
  public showattendanceProgress() {
    this.$router.push({
      path: '/impact-attendance',
      query: { name: 'attendance' },
    });
  }
}
